import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import InvitationAcceptPage from "./pages/InvitationAcceptPage";
import Layout from "./pages/Layout";
import ProfilePage from "./pages/ProfilePage";
import AlumniTab from "./components/alumni_tab/AlumniTab";
import SingleAlumni from "./pages/SingleAlumni";
import PostRoutes from "./components/posts/PostRoutes";

export default function App() {
  const routes = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
      loader: () => {
        localStorage.clear();
        return null;
      },
    },
    {
      path: "/login",
      element: <LandingPage />,
    },
    {
      path: "/forgot-password",
      element: <LandingPage />,
    },
    {
      path: "/reset-password",
      element: <LandingPage />,
    },
    {
      path: "/dashboard",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <ProfilePage />,
        },

        {
          path: "alumnis",
          element: <AlumniTab />,
        },
        {
          path: "alumni/:id",
          element: <SingleAlumni />,
        },
        ...PostRoutes,
      ],
    },
    {
      path: "/invitations/accept",
      element: <InvitationAcceptPage />,
    },
  ]);

  return <RouterProvider router={routes} />;
}
